export default {
  organizations: {
    switchOrganization: 'Switch organization',
    noOrganizations: 'No organizations',
    createNew: 'Create new',
    selectOrganization: 'Select an organization',
    members: 'members',
    invite: 'Invite',
    inviteSubtitle: 'Add team members',
    manageOrganizations: 'Manage organizations',
    create: {
      title: 'Create Organization',
      confirmButton: 'Create Organization',
      nameLabel: 'Organization Name',
      namePlaceholder: 'Enter organization name',
      nameRequired: 'Organization name is required',
      nameTooShort: 'Name must be at least 2 characters',
      nameTooLong: 'Name must be less than 100 characters',
      slugLabel: 'URL Slug',
      slugPlaceholder: 'organization-slug',
      slugHint: 'Used in URLs and must be unique',
      slugRequired: 'Slug is required',
      slugInvalid: 'Slug can only contain lowercase letters, numbers, and hyphens',
      slugTooShort: 'Slug must be at least 3 characters',
      slugTooLong: 'Slug must be less than 50 characters',
      legalSection: 'Legal Information (Optional)',
      legalNameLabel: 'Legal Name',
      taxIdLabel: 'Tax ID',
      addressLabel: 'Address',
      countryLabel: 'Country',
      contactSection: 'Contact Information (Optional)',
      contactEmailLabel: 'Contact Email',
      contactPhoneLabel: 'Contact Phone',
      websiteLabel: 'Website',
      emailInvalid: 'Please enter a valid email address',
      websiteInvalid: 'Please enter a valid URL starting with http:// or https://',
      createFailed: 'Failed to create organization. Please try again.'
    }
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noResults: 'No results found',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    previous: 'Previous',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    actions: 'Actions',
    settings: 'Settings',
    logout: 'Logout',
    profile: 'Profile',
    help: 'Help',
    about: 'About',
    home: 'Home',
    dashboard: 'Dashboard',
    notifications: 'Notifications',
    retry: 'Retry',
    theme: {
      light: 'Light',
      dark: 'Dark',
      system: 'System',
      title: 'Theme',
      lightTooltip: 'Light theme',
      darkTooltip: 'Dark theme',
      systemTooltip: 'Follow system preference'
    },
    docs: 'Documentation',
    all: 'All',
    peak: 'Peak',
    total: 'Total',
    selectAll: 'Select all',
    selectNone: 'Select none',
    others: 'others',
    apply: 'Apply'
  },
  dateRangePicker: {
    title: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    quickShortcuts: 'Quick Shortcuts',
    shortcuts: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisYear: 'This year',
      lastYear: 'Last year'
    }
  },
  errors: {
    general: 'An error occurred',
    notFound: 'Not found',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    serverError: 'Server error',
    networkError: 'Network error',
    validationError: 'Validation error',
    system: {
      title: 'Something went wrong',
      message: 'We encountered an unexpected error. Please try again later.',
      code: 'Error code'
    }
  },
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email',
    minLength: 'Minimum length is {min}',
    maxLength: 'Maximum length is {max}',
    pattern: 'Invalid format'
  },
  modals: {
    deleteConfirmation: {
      warning: 'Warning',
      cannotUndo: 'This action cannot be undone.',
      defaultMessage: 'Are you sure you want to delete this item?'
    }
  },
  userDrawer: {
    quickActions: 'Quick Actions',
    organizations: 'Organizations',
    notifications: 'notifications',
    orgs: 'orgs',
    role: {
      admin: 'Administrator',
      user: 'User'
    },
    shortcuts: {
      subscription: 'My Plan',
      subscriptionTooltip: 'Manage your subscription plan',
      invoices: 'Invoices',
      invoicesTooltip: 'View and download invoices',
      help: 'Help Center',
      helpTooltip: 'Get help and support',
      tickets: 'Support',
      ticketsTooltip: 'View support tickets',
      team: 'Team',
      teamTooltip: 'Manage team members',
      api: 'API',
      apiTooltip: 'Access API documentation'
    },
    settings: {
      title: 'Settings',
      profile: 'Personal Settings',
      security: 'Security Settings',
      organization: 'Organization Settings'
    }
  },
  apps: {
    home: {
      title: 'Home',
      description: 'Home page'
    },
    dashboard: {
      title: 'Dashboard',
      description: 'Reports and analytics for incidents and actions'
    },
    'production-lines': {
      title: 'Production Lines',
      description: 'Industrial production lines management'
    },
    incidents: {
      title: 'Incidents',
      description: 'Incident management system'
    },
    actions: {
      title: 'Actions',
      description: 'Action management for incident response'
    },
    mediasbox: {
      title: 'Mediasbox',
      description: 'Import and upload your media'
    },
    channels: {
      title: 'Channels',
      description: 'Create a website with your media'
    },
    scribe: {
      title: 'Scribe',
      description: 'Automatically subtitle your videos'
    },
    showcases: {
      title: 'Showcase',
      description: 'Create an attractive page to share'
    },
    analytics: {
      title: 'Analytics',
      description: 'Measure the impact of your videos'
    },
    streams: {
      title: 'Streams',
      description: 'Live video streaming with chat'
    },
    studio: {
      title: 'Studio',
      description: 'AI-powered video generation'
    },
    record: {
      title: 'Record',
      description: 'Record screen or camera'
    },
    playground: {
      title: 'Playground',
      description: 'Test and development area'
    }
  },
  upload: {
    title: 'Uploads',
    browseFiles: 'Browse Files',
    dropZone: {
      title: 'Drag and drop files here',
      subtitle: 'or click to browse'
    },
    stats: {
      total: 'Total',
      active: 'Active',
      completed: 'Completed'
    },
    actions: {
      startAll: 'Start All',
      clearCompleted: 'Clear Completed',
      clearAll: 'Clear All'
    },
    status: {
      pending: 'Pending',
      uploading: 'Uploading',
      paused: 'Paused',
      completed: 'Completed',
      error: 'Error'
    },
    empty: 'No uploads yet',
    errorDetails: 'Error Details',
    hint: 'You can also drag and drop files anywhere on the page',
    overlay: {
      title: 'Drop files to upload',
      subtitle: 'Release to start uploading'
    }
  }
}
